export const constants =  {
  tabs: {
    general: ['Auction Details'],
    clerk: ['Items List', 'Live Auction'],
    admin: ['Check-in', 'Invoices']
  }
};
